"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculate_driving_distance = exports.fetch_employees = exports.geocode_address = exports.fetch_isochrone_cached = exports.fetch_isochrone = void 0;
const browser_1 = __importDefault(require("@gibme/fetch/browser"));
const common_1 = require("./common");
const crypto_1 = require("crypto");
const hash = (obj) => (0, crypto_1.createHash)('sha256')
    .update(JSON.stringify(obj))
    .digest('hex');
const fetch_isochrone = (lat_1, lng_1, ...args_1) => __awaiter(void 0, [lat_1, lng_1, ...args_1], void 0, function* (lat, lng, minutes = 45, contoursCount = 3, profile = 'driving', mapbox_access_token = common_1.mapbox_token) {
    const id = hash({ lat, lng, minutes, contoursCount, profile });
    const contours = [];
    const labels = [];
    {
        const interval = minutes / contoursCount;
        for (let i = 1; i <= contoursCount; i++) {
            labels.push(Math.round(interval * i));
        }
    }
    {
        const interval = (minutes * 0.965) / contoursCount;
        for (let i = 1; i <= contoursCount; i++) {
            contours.push(Math.round(interval * i));
        }
    }
    const qs = new URLSearchParams();
    qs.set('contours_minutes', contours.join(','));
    qs.set('polygons', 'true');
    qs.set('access_token', mapbox_access_token);
    const response = yield (0, browser_1.default)(`https://api.mapbox.com/isochrone/v1/mapbox/${profile}/${lng},${lat}?${qs.toString()}`);
    const data = yield response.json();
    if (!data.features || data.features.length === 0) {
        throw new Error('Could not retrieve contour information');
    }
    return { data, contours, labels, id };
});
exports.fetch_isochrone = fetch_isochrone;
const cache = new Map();
const fetch_isochrone_cached = (lat_1, lng_1, ...args_1) => __awaiter(void 0, [lat_1, lng_1, ...args_1], void 0, function* (lat, lng, minutes = 45, contoursCount = 3, profile = 'driving', mapbox_access_token = common_1.mapbox_token) {
    const id = hash({ lat, lng, minutes, contoursCount, profile });
    const check = cache.get(id);
    if (check) {
        return check;
    }
    const response = yield (0, browser_1.default)(`/js/${id}.json`);
    if (response.ok) {
        const data = yield response.json();
        cache.set(id, data);
        return data;
    }
    const data = yield (0, exports.fetch_isochrone)(lat, lng, minutes, contoursCount, profile, mapbox_access_token);
    cache.set(id, data);
    return data;
});
exports.fetch_isochrone_cached = fetch_isochrone_cached;
const geo_cache = new Map();
const geocode_address = (address_1, ...args_1) => __awaiter(void 0, [address_1, ...args_1], void 0, function* (address, mapbox_access_token = common_1.mapbox_token) {
    const id = hash({ address });
    const check = geo_cache.get(id);
    if (check) {
        return check;
    }
    try {
        const qs = new URLSearchParams();
        qs.set('limit', '1');
        qs.set('access_token', mapbox_access_token);
        const url = [
            'https://api.mapbox.com/geocoding/v5/mapbox.places/',
            `${encodeURIComponent(address)}.json`,
            `?${qs.toString()}`
        ].join('');
        const response = yield (0, browser_1.default)(url);
        if (response.ok) {
            const data = yield response.json();
            if (data.features && data.features.length > 0) {
                const result = {
                    location: data.features[0].center,
                    id
                };
                geo_cache.set(id, result);
                return result;
            }
        }
    }
    catch (_a) { }
});
exports.geocode_address = geocode_address;
const fetch_employees = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield (0, browser_1.default)('/mgmt/employees.json');
        if (response.ok) {
            return response.json();
        }
        return [];
    }
    catch (_a) {
        return [];
    }
});
exports.fetch_employees = fetch_employees;
const calculate_driving_distance = (employee_1, office_1, ...args_1) => __awaiter(void 0, [employee_1, office_1, ...args_1], void 0, function* (employee, office, mapbox_access_token = common_1.mapbox_token) {
    var _a, _b, _c;
    try {
        const response = yield (0, browser_1.default)('https://api.mapbox.com/directions/v5/mapbox/driving/' +
            `${(_a = employee.location) === null || _a === void 0 ? void 0 : _a.location[0]},${(_b = employee.location) === null || _b === void 0 ? void 0 : _b.location[1]};` +
            `${office.lng},${office.lat}?access_token=${mapbox_access_token}`);
        if (!response.ok) {
            console.error(`Error: ${response.url} ${response.status} ${response.statusText}`);
            return undefined;
        }
        const json = yield response.json();
        const route = (_c = json.routes) === null || _c === void 0 ? void 0 : _c.shift();
        if (!route) {
            return undefined;
        }
        const distanceMeters = route.distance * 1.035;
        const distanceMiles = distanceMeters / 1609.34;
        const durationSeconds = route.duration * 1.035;
        const durationMinutes = durationSeconds / 60;
        return {
            miles: parseFloat(distanceMiles.toFixed(2)),
            minutes: parseFloat(durationMinutes.toFixed(2))
        };
    }
    catch (error) {
        console.error(error.toString());
        return undefined;
    }
});
exports.calculate_driving_distance = calculate_driving_distance;
